import {Component} from '@angular/core';
import {MainComponent} from 'app/core/main.component';
import {AppService} from 'app/services/app.service';
import {NavigationService} from 'app/services/navigation.service';
import {UserModelService} from 'app/models/user-model.service';
import {ToolbarItem} from 'app/entities/toolbarItem';
import {ViewEncapsulation} from '@angular/core';
import {ShiftModelService} from 'app/models/shift-model.service';
import {OtherModelService} from 'app/models/other-model.service';
import {FormModalComponent} from 'app/components/shared/formModal/item';

@Component({
  selector: 'app-toolbar',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ToolbarComponent extends MainComponent {

  shiftModelService: ShiftModelService;
  otherModelService: OtherModelService;

  items: ToolbarItem[] = [];

  constructor(
    appService: AppService,
    navigationService: NavigationService,
    userModelService: UserModelService,
    shiftModelService: ShiftModelService,
    otherModelService: OtherModelService,
  ) {
    super(appService, navigationService, userModelService);

    this.shiftModelService = shiftModelService;
    this.otherModelService = otherModelService;

    this.getMenuItems();
  }

  getMenuItems() {
    this.items = [
      {
        id: 'profile',
        title: 'profile',
        link: 'profile',
        notification: false,
        open: false,
        disabled: false,
        permission: 'updateOwnWorksheet',
        subMenu: [],
      },
      {
        id: 'users',
        title: 'users',
        link: 'workers',
        notification: false,
        open: false,
        disabled: false,
        permission: 'pwaWorkerList',
        subMenu: [],
      },
      {
        id: 'dash',
        title: 'dash',
        link: 'dashboard',
        notification: this.shiftModelService.notificationActive,
        open: false,
        disabled: false,
        permission: 'shiftPageView',
        subMenu: [],
      },
      {
        id: 'notices',
        title: 'notices',
        link: 'notices',
        notification: false,
        open: false,
        disabled: true,
        subMenu: [],
      },
      {
        id: 'messages',
        title: 'messages',
        link: 'messages',
        notification: false,
        open: false,
        disabled: true,
        subMenu: [],
      },
      // SAKURA-260 Старый код с подпунктами меню:
      // {
      //   id: 'more',
      //   title: 'more',
      //   link: null,
      //   notification: false,
      //   open: false,
      //   disabled: false,
      //   subMenu: [
      //     {
      //       id: 'values',
      //       title: 'ТМЦ',
      //       link: 'inventory',
      //       notification: false,
      //       open: false,
      //       disabled: false,
      //       permission: 'viewOwnUniform',
      //     },
      //     {
      //       id: 'fines',
      //       title: 'Штрафы и премии',
      //       link: 'directory',
      //       notification: false,
      //       open: false,
      //       disabled: false,
      //       permission: 'pwaDirectory',
      //     },
      //     {
      //       id: 'persacc',
      //       title: 'Личный счет',
      //       link: 'account',
      //       notification: false,
      //       open: false,
      //       disabled: false,
      //       permission: 'pwaPersonalBill',
      //     },
      //     {
      //       id: 'accountable',
      //       title: 'Подотчет',
      //       link: 'accountable',
      //       notification: false,
      //       open: false,
      //       disabled: false,
      //       permission: 'pwaSubreport'
      //     },
      //     {
      //       id: 'calend',
      //       title: 'Календарь',
      //       link: 'calendar',
      //       notification: false,
      //       open: false,
      //       disabled: false,
      //       permission: 'viewCalendarEventsPWA',
      //     },
      //     {
      //       id: 'documents',
      //       title: 'Мои документы',
      //       link: 'documents',
      //       notification: false,
      //       open: false,
      //       disabled: false,
      //       permission: 'viewOwnDocuments'
      //     },
      //     {
      //       id: 'indicators',
      //       title: 'Мои показатели',
      //       link: 'indicators',
      //       notification: false,
      //       open: false,
      //       disabled: false,
      //       permission: 'pwaIndicators'
      //     },
      //     {
      //       id: 'settings',
      //       title: 'Настройки',
      //       link: 'settings',
      //       notification: false,
      //       open: false,
      //       disabled: true,
      //     },
      //     {
      //       id: 'exit',
      //       title: 'Выход',
      //       link: () => {
      //         this.userModelService.logout();
      //         this.navigationService.goTo('authentication', {}, true);
      //       },
      //       color: 'red',
      //       notification: false,
      //       open: false,
      //       disabled: false,
      //     },
      //   ],
      // },
    ];
  }

  clickOnItem(item: ToolbarItem) {
    this.appService.appModalService.closeTopModal();
    if (!item.disabled && this.appService.isShowToolbar) {
      if (item.link) {
        if (typeof item.link === 'string') {
          this.items.forEach((i) => i.open = false);
          this.navigationService.goTo(item.link);
        } else {
          item.link();
        }
      } else if (item.subMenu.length && !this.appService.appModalService.submenuShow) {
        // SAKURA-260 Старый код, который открывает попап с подпунктами меню:
        // item.open = true;
        // this.appService.appModalService.openDropDownMenuModal(item, (callback)=> {});
      }
    }
  }

  isMenuActive(item: ToolbarItem) {
    if (item.subMenu?.length) {
      return item.subMenu.some((i) => this.navigationService.isCurrentUrl(i.link));
    } else {
      return this.navigationService.isCurrentUrl(item.link);
    }
  }

  isPermissionOK(item: ToolbarItem) {
    if (item.permission) {
      return this.userModelService.isLogin() && this.userModelService.permissions.checkPermission(item.permission);
    }

    return true;
  }

  closeItem(item: ToolbarItem) {
    item.open = false;
  }

  openBugReport() {
    this.appService.appModalService.openModal(FormModalComponent, {
      getFormSettings: this.otherModelService.getBugReportForm(),
      saveForm: this.otherModelService.saveBugReportForm(),
      // updateForm: this.testModelService.updateForm()
    }, 'full', 'full', (result) => {

    });

    // (window as any).showCollectorDialog();

  }

  openMenu() {
    this.appService.menuOpen();
  }
}
